var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-content",style:(_vm.customStyle),on:{"touchend":_vm.trackSelect,"touchmove":function($event){_vm.isScrolled = true}}},[_c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"nio-player"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b144ca8c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/marketing/components/video.vue
// module id = 652
// module chunks = 1 2